const React = require("react");
const { ChatbotProvider } = require("./src/context/ChatbotContext");
const { SessionProvider } = require("./src/context/SessionContext");
const Chatbot = require("./src/components/Chatbot").default;
const PageSlugUpdater = require("./src/components/PageSlugUpdater").default;

// Import the CSS to ensure it's included in the bundle
require("./src/styles/chatbot.css");

// Wrap the entire app with the Context Providers and render Chatbot persistently
exports.wrapRootElement = ({ element }) => {
  return (
    <SessionProvider>
      <ChatbotProvider>
        {element} {/* The rest of your app */}
        <Chatbot /> {/* Persistent Chatbot */}
      </ChatbotProvider>
    </SessionProvider>
  );
};

// Use wrapPageElement to update the context with the current page's slug
exports.wrapPageElement = ({ element, props }) => {
  // PageSlugUpdater will read props.pageContext.slug and update the context
  return <PageSlugUpdater element={element} props={props} />;
}; 